export const darkTheme = {
  bg: '#020B1F',
  bgCard: 'rgba(39, 55, 80, 0.4)',
  bgCardHover: 'rgba(0, 184, 255, 0.08)',
  bgInput: 'rgba(2, 11, 31, 0.6)',
  bgModal: '#0D1B2E',
  bgOverlay: 'rgba(2, 11, 31, 0.8)',
  bgHeader: 'rgba(39, 55, 80, 0.5)',
  borderHeader: 'rgba(174, 182, 196, 0.15)',
  primary: '#F3F5F7',
  secondary: '#AEB6C4',
  accent: '#00B8FF',
  accentDark: '#0088CC',
  accentSecondary: '#273750',
  border: 'rgba(174, 182, 196, 0.15)',
  borderHover: '#00B8FF',
  borderInput: 'rgba(174, 182, 196, 0.3)',
  success: '#00D084',
  successBg: 'rgba(0, 208, 132, 0.15)',
  warning: '#FFB300',
  warningBg: 'rgba(255, 179, 0, 0.15)',
  error: '#FF4757',
  errorBg: 'rgba(255, 71, 87, 0.15)',
  info: '#00B8FF',
  infoBg: 'rgba(0, 184, 255, 0.15)',
};

export const lightTheme = {
  bg: '#F0F4FA',
  bgCard: '#FFFFFF',
  bgCardHover: 'rgba(0, 184, 255, 0.05)',
  bgInput: '#FFFFFF',
  bgModal: '#FFFFFF',
  bgOverlay: 'rgba(0, 0, 0, 0.4)',
  bgHeader: '#223A5E',
  borderHeader: 'rgba(255,255,255,0.1)',
  primary: '#1A2740',
  secondary: '#5A6A85',
  accent: '#0099DD',
  accentDark: '#0077BB',
  accentSecondary: '#E8F4FB',
  border: '#D0D8E8',
  borderHover: '#0099DD',
  borderInput: '#C0CCE0',
  success: '#00A86B',
  successBg: 'rgba(0, 168, 107, 0.12)',
  warning: '#E09000',
  warningBg: 'rgba(224, 144, 0, 0.12)',
  error: '#E0002A',
  errorBg: 'rgba(224, 0, 42, 0.12)',
  info: '#0099DD',
  infoBg: 'rgba(0, 153, 221, 0.12)',
};

export function getStyles(theme) {
  return {
    btnPrimary: {
      background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`,
      border: 'none', borderRadius: '8px', padding: '8px 16px',
      fontSize: '13px', cursor: 'pointer', color: '#FFFFFF',
      fontWeight: '600', fontFamily: "'Montserrat', sans-serif",
    },
    btnSecondary: {
      background: 'transparent',
      border: `0.5px solid ${theme.borderInput}`,
      borderRadius: '8px', padding: '8px 16px', fontSize: '13px',
      cursor: 'pointer', color: theme.secondary,
      fontFamily: "'Montserrat', sans-serif",
    },
    btnDanger: {
      background: theme.errorBg,
      border: `0.5px solid ${theme.error}40`,
      borderRadius: '8px', padding: '8px 16px', fontSize: '13px',
      cursor: 'pointer', color: theme.error,
      fontFamily: "'Montserrat', sans-serif",
    },
    inputStyle: {
      width: '100%', padding: '10px 14px', fontSize: '13px',
      border: `0.5px solid ${theme.borderInput}`,
      borderRadius: '8px', outline: 'none',
      color: theme.primary, background: theme.bgInput,
      boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif",
    },
    labelStyle: {
      fontSize: '11px', color: theme.secondary, display: 'block',
      marginBottom: '6px', fontWeight: '500', letterSpacing: '1px',
    },
    cardStyle: {
      background: theme.bgCard, borderRadius: '12px',
      border: `0.5px solid ${theme.border}`, padding: '16px 20px',
    },
    overlayStyle: {
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: theme.bgOverlay, display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    },
    modalStyle: {
      background: theme.bgModal, borderRadius: '16px', padding: '28px',
      width: '100%', maxWidth: '520px', maxHeight: '90vh',
      overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      border: `0.5px solid ${theme.border}`,
    },
    seccionTitulo: {
      fontSize: '11px', fontWeight: '700', color: theme.secondary,
      marginBottom: '12px', letterSpacing: '1.5px', textTransform: 'uppercase',
    },
    subTitulo: {
      fontSize: '13px', fontWeight: '600', color: theme.primary, marginBottom: '10px',
    },
  };
}

// Exportaciones legacy para compatibilidad
export const colors = darkTheme;
export const btnPrimary = getStyles(darkTheme).btnPrimary;
export const btnSecondary = getStyles(darkTheme).btnSecondary;
export const inputStyle = getStyles(darkTheme).inputStyle;
export const labelStyle = getStyles(darkTheme).labelStyle;
export const overlayStyle = getStyles(darkTheme).overlayStyle;
export const modalStyle = getStyles(darkTheme).modalStyle;
export const seccionTitulo = getStyles(darkTheme).seccionTitulo;
export const subTitulo = getStyles(darkTheme).subTitulo;